/** Pure manifest filtering/search for the `/assets` sidebar + entry list — no DOM, fully unit-testable. */

import type { AssetCategory, BakeManifestEntry } from "@red-opus/baker/schema";

export interface CategoryCount {
  readonly category: AssetCategory;
  readonly count: number;
}

/** Counts entries per category, in the given category display order. */
export function groupByCategory(
  entries: readonly BakeManifestEntry[],
  categories: readonly AssetCategory[],
): CategoryCount[] {
  return categories.map((category) => ({
    category,
    count: entries.filter((entry) => entry.category === category).length,
  }));
}

/** Case-insensitive substring search over an entry's id and source path. Empty/whitespace query matches everything. */
export function searchEntries(entries: readonly BakeManifestEntry[], query: string): BakeManifestEntry[] {
  const needle = query.trim().toLowerCase();
  if (needle.length === 0) return [...entries];
  return entries.filter(
    (entry) => entry.id.toLowerCase().includes(needle) || entry.sourcePath.toLowerCase().includes(needle),
  );
}
